import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { Footer } from "./Footer";
import { Toaster } from "sonner";
import ChangePasswordModal from "../auth/ChangePasswordModal";

export const AppShell = () => {
  const [pwModalOpen, setPwModalOpen] = useState(false);
  const [sidebarMobileOpen, setSidebarMobileOpen] = useState(false);

  return (
    <div className="App min-h-screen flex flex-col bg-white">
      <Header
        onOpenChangePassword={() => setPwModalOpen(true)}
        onToggleSidebar={() => setSidebarMobileOpen((v) => !v)}
      />
      <div className="flex flex-1 min-h-0">
        <Sidebar
          mobileOpen={sidebarMobileOpen}
          onMobileClose={() => setSidebarMobileOpen(false)}
        />
        <main
          data-testid="app-main"
          className="flex-1 min-w-0 overflow-y-auto bg-white"
        >
          <div className="pb-container px-4 sm:px-6 lg:px-10 py-5 sm:py-8">
            <Outlet />
          </div>
        </main>
      </div>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            border: "1px solid rgba(2,39,80,0.15)",
            borderRadius: 0,
            background: "#fff",
            color: "#022750",
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
      {/* PW-Wechsel ist FREIWILLIG — kein Zwang mehr beim Login.
          forced=true wird gar nicht mehr ausgelöst, das `muss_passwort_aendern`-Flag
          aus dem User-Profil wird bewusst ignoriert. */}
      <ChangePasswordModal
        open={pwModalOpen}
        forced={false}
        onClose={() => setPwModalOpen(false)}
      />
    </div>
  );
};
